import React from "react";
import axios from "axios";
import ReportsError from './ReportsError';
import { getFromLocalStorage } from './Utilities';

class ReportsLoginDomainTableBody extends React.Component {
    constructor(props) {
        super(props);

        var endpoint = "login/stats/domains?turnoffdebug=1";

        // Initializing state with the endpoint URL
        this.state = {
            url: "react/process?endpoint=" + endpoint + "&hourly_cutoff=0",
            domains: [],
            error: null,
            isLoading: false
        }
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        // Fetch new data if the 'next' prop changes
        if (prevProps.next !== this.props.next) {
            this.getData();
        }
    }

    // Function to fetch data from the server
    getData() {
        var url = this.state.url;
        if (this.props.next > 0) url += "&next=" + this.props.next;
        url += "&turnoffdebug=1";

        axios.get(url).then(response => this.formatData(response.data));
    }

    // Function to format the fetched data
    formatData(data) {

        let domains = data.domains || [];
        let error = data?.error || null;

        // Limiting the number of domains to 25
        domains = domains.slice(0, 25);

        this.setState({ domains, error: error?.message, isLoading: true });

        if(error) this.props.hasError(error);
    }

    render() {
        const { domains, isLoading } = this.state;

        if (!isLoading) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big"></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        } else if (Object.values(domains).length === 0) {
            // Handling no results found
            return (
                <ReportsError error={this.state.error} />
            );
        } else {
            // Displaying domains
            return (
                <tbody>
                    {domains.map(domain => (
                        <tr key={domain.domain}>
                            <td>{domain.domain}</td>
                            <td>{domain.signups}</td>
                            <td>{domain.types.new}</td>
                            <td>{domain.types.returning}</td>
                            <td>{domain.popular}</td>
                        </tr>
                    ))}
                </tbody>
            );
        }
    }
}

class ReportsLoginDomain extends React.Component {
    constructor(props) {
        super(props);
        console.log('Login Domains');

        // Initializing state
        this.state = {
            next: 0,
            total: null,
            error: null
        };
    }

    // Function to set the total count of entries
    setTotalCount = (total) => {
        total = total.replace("~", "").replace(",", "");
        this.setState({ total: parseInt(total, 10) });
    };

    // Function to handle pagination
    paginationHandler = (next) => {
        this.setState({ next });
    };

    hasError(error){
        this.setState({
            error: error?.message
        })
    }

    render() {
        return (
            <div className="feed-domainlist">
                <table id="basic-datatable" className="table dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>Domain</th>
                            <th>Sign Ins</th>
                            <th>New</th>
                            <th>Returning</th>
                            <th>Most Popular</th>
                        </tr>
                    </thead>
                    <ReportsLoginDomainTableBody 
                        next={this.state.next} 
                        type={this.props.type} 
                        key={this.state.total} 
                        hasError={this.hasError.bind(this)} 
                    />
                </table>             
            </div>
        );
    }
}

export default ReportsLoginDomain;
